// Short display names for the handful of canonical topics whose real names are
// too long to sit in a table row.
//
// The canonical name stays the identifier EVERYWHERE — queries, URLs, the
// question bank, mastery rows. This map is display only, so nothing downstream
// has to know a topic is being abbreviated. A topic with no entry renders its
// full name, which is the case for most of them.
//
// Kept deliberately conservative: shortened enough to fit a column, never so
// short that a student cannot tell which topic it is. "Nonlinear Equations &
// Systems" is recognisable; "Nonlinear" would not be.

const SHORT: Record<string, string> = {
  'Nonlinear Equations in 1 Variable and Systems of Equations in 2 Variables':
    'Nonlinear Equations & Systems',
  'Ratios, Rates, Proportional Relationships, and Units': 'Ratios, Rates & Proportions',
  'Systems of 2 Linear Equations in 2 Variables': 'Systems of 2 Linear Equations',
  'Linear Inequalities in 1 or 2 Variables': 'Linear Inequalities',
  'One-Variable Data: Distributions and Measures of Center and Spread': 'One-Variable Data',
  'Two-Variable Data: Models and Scatterplots': 'Two-Variable Data & Scatterplots',
  'Probability and Conditional Probability': 'Probability',
  'Inference from Sample Statistics and Margin of Error': 'Inference from Sample Statistics',
  'Evaluating Statistical Claims: Observational Studies and Experiments':
    'Evaluating Statistical Claims',
}

/** The canonical topics that have a short form — exported so a test can prove
 *  every key is a REAL topic. A typo'd key is silently dead code otherwise. */
export const SHORTENED_TOPICS: string[] = Object.keys(SHORT)

/** Display name for a topic — the short form when one exists, else the name itself. */
export function topicShortName(topic: string): string {
  return SHORT[topic] ?? topic
}

/** True when this topic is being displayed under a shortened name. */
export function isShortened(topic: string): boolean {
  return topic in SHORT
}
